import {
  AndroidOutlined,
  AppleOutlined,
  GlobalOutlined,
  LaptopOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import Feature from '@components/Feature'
import { useFeature } from '@utils/featureFlags'
import { Card, Flex, Form, Input, Space, Switch, Tag } from 'antd'
import { FC } from 'react'
import { SeatingArea as SeatingAreaModel } from '../../models/SeatingArea'
import { useAppSelector } from '../../store/hooks'
import { selectSeatingAreaById } from '../../store/SeatingAreaReducer'
import { updateVenueSeatingAreaBookingVisibility } from '../connectors/sevenrooms/service'
import { SeatingAreaAvatar } from './Avatar'

type Props = SBModelComponent<SeatingAreaModel> & {
  //
}

const VisibilityCardForm: FC<Props> = ({ id, model }) => {
  const { enabled: webBooking } = useFeature('webBooking')
  const item = model ? model : useAppSelector(selectSeatingAreaById(id!))

  if (!item || !item.venueSeatingAreas) return <></>

  const onFormValuesChange = (
    _: any,
    values: {
      appBookingEnable: boolean
      whatsappBookingEnable: boolean
      companyBackOfficeBookingEnable: boolean
      webBookingEnable: boolean
    }
  ) => {
    if (!item || !item.venueSeatingAreas) return
    updateVenueSeatingAreaBookingVisibility({
      venueSeatingAreas: item.venueSeatingAreas.map((e) => e.id),
      ...values,
    })
  }

  return (
    <Card title={<SeatingAreaAvatar id={item.id} />}>
      <Form
        initialValues={item.venueSeatingAreas[0]}
        onValuesChange={onFormValuesChange}
      >
        <Flex vertical gap={10}>
          <Form.Item hidden noStyle name={'id'}>
            <Input />
          </Form.Item>
          <Space className="w-full space-between">
            <Tag color={'green'}>
              <Space size={2}>
                <WhatsAppOutlined /> WhatsApp
              </Space>
            </Tag>

            <Form.Item name={'whatsappBookingEnable'} noStyle>
              <Switch
                checkedChildren={'Enabled'}
                unCheckedChildren={'Disabled'}
              />
            </Form.Item>
          </Space>
          <Space className="w-full space-between">
            <Tag color={'blue'}>
              <Space size={2}>
                <AppleOutlined /> <AndroidOutlined /> Mobile application
              </Space>
            </Tag>

            <Form.Item name={'appBookingEnable'} noStyle>
              <Switch
                checkedChildren={'Enabled'}
                unCheckedChildren={'Disabled'}
              />
            </Form.Item>
          </Space>
          <Space className="w-full space-between">
            <Tag color={'purple'}>
              <Space size={2}>
                <LaptopOutlined /> Company back office
              </Space>
            </Tag>

            <Form.Item name={'companyBackOfficeBookingEnable'} noStyle>
              <Switch
                checkedChildren={'Enabled'}
                unCheckedChildren={'Disabled'}
              />
            </Form.Item>
          </Space>
          {webBooking ? (
            <Space className="w-full space-between">
              <Feature flag="webBooking" preview="inline">
                <Tag color={'cyan'}>
                  <Space size={2}>
                    <GlobalOutlined /> Website
                  </Space>
                </Tag>
              </Feature>

              <Form.Item name={'webBookingEnable'} noStyle>
                <Switch
                  checkedChildren={'Enabled'}
                  unCheckedChildren={'Disabled'}
                />
              </Form.Item>
            </Space>
          ) : (
            /*
              Rendered as nothing, but still registered: the bulk endpoint
              writes every flag with `?? false`, so dropping the field would
              clear web_booking_enable on every unrelated save. Hidden keeps
              the loaded value in the payload while the surface stays dark.
            */
            <Form.Item name={'webBookingEnable'} noStyle hidden>
              <Switch />
            </Form.Item>
          )}
        </Flex>
      </Form>
    </Card>
  )
}

type VisibilityCardFormType = { VisibilityCardForm: typeof VisibilityCardForm }

export { VisibilityCardForm, type VisibilityCardFormType }
